export default {
    label_task:{
        en:"Distributors Stocks",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Distributor Stocks",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Distributor Stocks",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Distributor Stocks",
        bn:'ব্যবহারকারীর বিবরণ'
    },

}